import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        &copy; {new Date().getFullYear()} Fresh Wave Solutions Limited &nbsp;·&nbsp;
        <em>Trusted. Reliable. Excellence in Every Clean.</em>
        <br /><br />
        Designed by <a href="https://tadeyemi.co.uk" target="_blank" rel="noopener noreferrer">Taiwo</a>
      </p>
    </footer>
  );
}
